module.exports = __webpack_public_path__ + "img/graphique-leucemies.295ecdb6.jpg";